import axios from "axios";

import {getRefreshedArtistToken} from "./refreshToken";
import {store} from "../index";
import {initiateLogoutArtist} from "../store/auth/authActions";
import {getArtistToken} from "./axiosTokenStoreHandler";

axios.interceptors.request.use(
    async (config) => {
        const tokens = getArtistToken()
        if (tokens?.artistToken) {
            config.headers = {
                ...config.headers,
                authorization: `Bearer ${tokens?.artistToken}`,
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error?.config;
        if (error?.response?.status === 401) {
            if (!config?.sent) {
                config.sent = true;
                const response = await getRefreshedArtistToken();
                if (response?.artistToken) {
                    config.headers = {
                        ...config.headers,
                        authorization: `Bearer ${response.artistToken}`,
                    };
                    return axios(config);
                }
                // Refresh failed – logout artist so user is redirected to login
                setTimeout(() => store.dispatch(initiateLogoutArtist()), 0)
            } else {
                setTimeout(() => store.dispatch(initiateLogoutArtist()), 0)
            }
        }
        return Promise.reject(error);
    }
);

export const axiosPrivate = axios
